import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-2" }

import ChipButton from '@/shared/components/ChipButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TagsList',
  props: {
	checks: { type: Array, required: true },
},
  emits: ['onChange'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toggle = (check: any) => {
	check.selected = !check.selected;
	emit('onChange', check);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.checks, (check) => {
      return (_openBlock(), _createBlock(ChipButton, {
        key: check.name,
        label: check.name,
        selected: check.selected,
        onClick: ($event: any) => (toggle(check))
      }, null, 8, ["label", "selected", "onClick"]))
    }), 128))
  ]))
}
}

})